<script setup>
import { ref, onMounted, computed } from 'vue';
import { retrieve_child } from '@/services/child';
import dayjs from 'dayjs'
import { swalError } from '@/helper';

const props = defineProps({
  child_id:{
    required: true
  }
})

const child = ref({})
const currentSub = ref({})
let interval = null
const now = ref(dayjs(new Date()))

onMounted(async()=>{
  await get_child_subscription()
  set_current_subscription()
  interval = setInterval(() => {
    now.value = dayjs(new Date());
  }, 30000); // Check every 30 seconds
})

const showDisabled = computed(()=>{
  // Show disabled overlay if:
  // 1. No subscription exists
  // 2. Subscription is expired
  // 3. Subscription is active but past end_date (edge case before backend updates)
  
  if (!currentSub.value){
    return true
  }
  
  if (currentSub.value.attributes?.status === 'expired'){
    return true
  }
  
  // For active subscriptions, check if end_date has passed (shouldn't happen with auto-rotation, but safety check)
  if (currentSub.value.attributes?.status === 'active' && currentSub.value.attributes?.end_date){
    let end_date = dayjs(currentSub.value.attributes.end_date)
    let diff = end_date.diff(now.value)
    if (diff < 0){
      return true
    }
  }
  
  return false
})

function set_current_subscription(){
  // Find active subscription (pending ones will be auto-activated by backend)
  currentSub.value = child.value.subscriptions?.find(subs => subs.attributes.status === 'active')
}

async function get_child_subscription(){
  let response = await retrieve_child(props.child_id, '?subscription=true&subscription_data=true')
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data.included?.length != 0){
    child.value = parseSubscription(response.result.data)
  }
}

function parseSubscription(result){
  let tempChild = result.data
  let child_subscriptions = result.included.filter(item => item.type == 'child_subscription')
  child_subscriptions.forEach(childSub => {
    childSub.subscription = result.included.filter(item=>item.type == 'subscription').find(sub => childSub.attributes.subscription_id == sub.id)
  });
  tempChild.subscriptions = child_subscriptions
  return tempChild
}
</script>

<template>
  <div v-if="showDisabled">
    <div class="disabled-card"></div>
    
    <!-- Expired Subscription Notification Card -->
    <div class="expired-notification">
      <div class="card shadow-lg border-0">
        <div class="card-body text-center p-4">
          <div class="mb-3">
            <vue-feather type="alert-circle" size="3rem" class="text-danger"></vue-feather>
          </div>
          <h4 class="text-danger mb-3">Subscription Expired</h4>
          <p class="text-muted mb-4">
            Your subscription has expired. Please renew your subscription to continue accessing assessments and interventions.
          </p>
          <router-link 
            :to="{ name: 'subscription' }" 
            class="btn btn-primary btn-lg"
          >
            <vue-feather type="refresh-cw" size="1rem" class="me-2"></vue-feather>
            Renew Subscription
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.disabled-card {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  cursor: not-allowed;
}

.expired-notification {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  max-width: 500px;
  width: 90%;
}

.expired-notification .card {
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>